import * as RX from 'reactxp';
import { Window } from '../../reducers/window';
import { applyBreakpoints } from '../../utils/breakpoints';
import { mapStateToProps } from '../../utils/mapper';
import { colors } from '../../utils/styles';

import { connect } from 'react-redux';

interface WrappedRoutes {
  children?: any;
  window: Window & { multiplier: number };
};

const styles = (multiplier, landscape) => ({
  outer: RX.Styles.createViewStyle({
    alignItems: 'center',
    backgroundColor: colors.background,
    flex: 1,
    flexDirection: 'column',
  }),
  wrappedRoutes: RX.Styles.createViewStyle({
    alignSelf: 'center',
    backgroundColor: colors.background,
    paddingBottom: 16 * multiplier,
    paddingHorizontal: landscape ? 40 * multiplier : 16 * multiplier,
    paddingTop: 16 * multiplier,
  }),
});

export class WrapperRoutes extends RX.Component<WrappedRoutes, RX.CommonProps> {

  constructor(props: any) {
    super(props);
  }

  public render() {
    const { window: { width, height, multiplier, landscape } } = this.props;

    return (
      <RX.View style={[styles(multiplier, landscape).outer, { minHeight: height - 154 }]}>
        <RX.View
          style={[
            styles(multiplier, landscape).wrappedRoutes,
            { flex: 1, width, flexBasis: 'auto' },
            ...applyBreakpoints(width, { lg: { paddingTop: 16, maxWidth: 1200 } })
          ]}
        >
          {this.props.children}
        </RX.View>
      </RX.View>
    );
  }

}

export default connect(mapStateToProps)(WrapperRoutes);



// WEBPACK FOOTER //
// ./src/components/wrapper_routes/index.tsx